import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthGuard } from '@/rtkQuery/features/services/auth';

const ProductListPage = lazy(() => import('@/pages/ProductListPage'));
const ProductDetailsPage = lazy(() => import('@/pages/ProductDetailsPage'));

export const ProductsRoutes = {
    path: '/products',
    children: [
        {
            index: true,
            element: <Navigate to="list" replace />
        },
        {
            path: 'list',
            element: <ProductListPage />
        },
        {
            path: 'yourOptions',
            element: (
                <AuthGuard>
                    <ProductListPage />
                </AuthGuard>
            )
        },
        {
            path: 'category/:subCategory',
            element: <ProductListPage />
        },
        {
            path: 'details/:productId',
            element: <ProductDetailsPage />
        },
    ],
};
